import { render, staticRenderFns } from "./DrawerAppContent.vue?vue&type=template&id=be4d6d1c&scoped=true&"
import script from "./DrawerAppContent.vue?vue&type=script&lang=js&"
export * from "./DrawerAppContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be4d6d1c",
  null
  
)

export default component.exports